document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-home-product-strip]').forEach(function (slider) {
    const viewport = slider.querySelector('[data-home-product-strip-track]');
    const prev = slider.querySelector('[data-home-product-strip-prev]');
    const next = slider.querySelector('[data-home-product-strip-next]');

    if (!viewport || !prev || !next) return;

    let hasMoved = false;

    prev.hidden = true;

    function updateArrows() {
      const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
      const currentScroll = viewport.scrollLeft;

      prev.hidden = !hasMoved || currentScroll <= 5;
      next.hidden = currentScroll >= maxScrollLeft - 5;
    }

    prev.addEventListener('click', function () {
      viewport.scrollBy({
        left: -viewport.clientWidth * 0.75,
        behavior: 'smooth'
      });

      setTimeout(updateArrows, 350);
    });

    next.addEventListener('click', function () {
      hasMoved = true;

      viewport.scrollBy({
        left: viewport.clientWidth * 0.75,
        behavior: 'smooth'
      });

      setTimeout(updateArrows, 350);
    });

    viewport.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    updateArrows();
  });
});